"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var s = _interopRequireWildcard(require("./styles"));

var _IconThreeDotsVertical = _interopRequireDefault(require("../../../../Icons/IconThreeDotsVertical"));

var _Icon = _interopRequireDefault(require("../../../../Icon"));

var _DarkDropdown = _interopRequireDefault(require("../../../../DarkDropdown/DarkDropdown"));

var _DarkButton = _interopRequireDefault(require("../../../../Button/DarkButton"));

var _DarkText = _interopRequireDefault(require("../../../../DarkText"));

var _IconInvite = _interopRequireDefault(require("../../../../Icons/IconInvite"));

var _helper = require("../../helper");

/* eslint-disable react/no-unused-prop-types */
var getUserActions = function getUserActions(props) {
  var userActions = [{
    type: 'PRIVATE_NOTE',
    iconType: 'lock',
    label: 'Create private note'
  }];
  var audioBtn = null;

  if (props.audioStatus === 'REQUESTED_MUTE') {
    audioBtn = {
      type: 'UNMUTE_AUDIO',
      iconType: 'record',
      label: 'Unmute audio'
    };
  } else {
    audioBtn = {
      type: 'MUTE_AUDIO',
      iconType: 'disabledRecord',
      label: 'Mute audio'
    };
  }

  userActions.unshift(audioBtn);
  var onStageBtn = null;

  if (props.isClassActive) {
    if ((0, _helper.isUserOnStage)(props.onStageStatus)) {
      onStageBtn = {
        type: 'REMOVE_FROM_STAGE',
        IconComponent: _IconInvite.default,
        label: 'Remove from stage'
      };
    } else {
      onStageBtn = {
        type: 'INVITE_ON_STAGE',
        IconComponent: _IconInvite.default,
        label: 'Bring on stage'
      };
    }

    userActions.push(onStageBtn);
  }

  return userActions;
};

var overlayItems = function overlayItems(props) {
  return function (close) {
    var onActionSelect = props.onActionSelect,
        userId = props.userId;
    var userActions = getUserActions(props);
    return React.createElement("div", {
      className: s.dropDownContainer
    }, userActions.map(function (action) {
      return React.createElement(_DarkDropdown.default.Item, {
        className: s.optionWrapper,
        onClick: function onClick() {
          close();
          onActionSelect(userId, action.type);
        },
        disabled: action.disabled
      }, action.IconComponent ? React.createElement(action.IconComponent, {
        className: s.optionIcon
      }) : React.createElement(_Icon.default, {
        type: action.iconType,
        className: s.optionIcon
      }), React.createElement(_DarkText.default, {
        fontSize: 12,
        color: "white"
      }, action.label));
    }));
  };
};

function UserActions(props) {
  return React.createElement(_DarkDropdown.default, {
    overlay: overlayItems(props),
    popupWidth: 177,
    placement: "bottomRight",
    popupWrapperClassName: s.dropdownContainer
  }, React.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, React.createElement(_DarkButton.default.IconButton, {
    className: s.accentButton
  }, React.createElement(_IconThreeDotsVertical.default, {
    className: s.actionIcon
  }))));
}

UserActions.defaultProps = {
  onActionSelect: function onActionSelect() {},
  onStageStatus: 'DEFAULT',
  audioStatus: 'PLAYING'
};
UserActions.propTypes = {
  onActionSelect: _propTypes.default.func,
  onStageStatus: _propTypes.default.string,
  audioStatus: _propTypes.default.string,
  userId: _propTypes.default.string.isRequired
};
var _default = UserActions;
exports.default = _default;